export default __webpack_public_path__ + "static/media/Brianna.3cfc6125.png";